export default "__VITE_ASSET__BAQBD5B3__"